<template>
  <div class="columns is-centered">
    <div
      class="column is-two-thirds-tablet is-half-desktop"
      v-if="mode === 'resetPassword'"
    >
      <app-user-reset-password />
    </div>
  </div>
</template>

<script>
import AppUserResetPassword from 'components/auth/AppUserResetPassword';

export default {
  components: {
    AppUserResetPassword,
  },

  data() {
    return {};
  },

  computed: {
    mode() {
      return this.$route.query.mode;
    },
  },
};
</script>
